import React from 'react';

import s from './Search.module.scss';

type Props = {
  children: React.ReactNode;
};

export const SearchNoResult = ({ children }: Props) => {
  return <div className={s.noResult}>{children}</div>;
};
